import React, { useEffect, useState } from "react";
import loading from "../../../../assets/media/loader/dual-ring.svg";

function ConfirmEdit({
  short,
  original,
  title,
  setConfirmingEdit,
  editing,
  editLink,
}) {
  const [changeDetected, setChangeDetected] = useState(false);
  const [input, setInput] = useState(title);
  useEffect(() => {
    if (input === title || input.length === 0) {
      setChangeDetected(false);
    } else setChangeDetected(true);
  }, [changeDetected, input]);
  const handleSave = async () => {
    if (input === title || input.length === 0) return;
    await editLink(input);
  };

  return (
    <>
      {editing ? (
        <div className="fixed top-0 left-0 w-screen h-screen flex justify-center bg-semi-trans items-center z-[9991] backdrop-blur-sm">
          <div className="bg-white dark:bg-accent-600 p-[20px] rounded-lg">
            <img width={"30px"} src={loading} alt="" />
          </div>
        </div>
      ) : (
        <div className="fixed top-0 left-0 w-screen h-screen flex justify-center bg-semi-trans items-center z-[9991] backdrop-blur-sm">
          <div className="bg-white dark:bg-accent-600 p-[20px] rounded-lg max-w-[600px] w-full mx-20px">
            <div className="text-lg font-bold text-accent-800 dark:text-accent-100 mb-16px">
              Edit link
            </div>
            <div className="flex flex-col mb-16px">
              <label
                className="text-accent-300 dark:text-accent-200 font-medium text-sm mb-1"
                htmlFor="title"
              >
                Title
              </label>
              <input
                className="text-accent-700 dark:text-accent-100 dark:bg-accent-700 dark:border-none w-full border border-accent-100 rounded-md py-2 px-10px font-bold focus-within:outline-primary-500 dark:focus-within:outline dark:focus-within:outline-primary-500"
                type="text"
                id="title"
                placeholder="Type new title"
                value={input}
                onChange={(e) => setInput(e.target.value)}
              />
            </div>
            <div className="flex flex-col mb-16px select-none">
              <label
                className="text-accent-300 dark:text-accent-200 font-medium text-sm mb-1"
                htmlFor="original"
              >
                Original
              </label>
              <input
                className="w-full border text-accent-400 dark:text-accent-100 dark:bg-accent-700 disabled:hover:cursor-not-allowed dark:border-none disabled:dark:text-accent-300 select-none bg-primary-50 border-accent-100 rounded-md py-2 px-10px outline-none font-bold focus-within:border-primary-500"
                type="text"
                id="original"
                placeholder="Type new title"
                value={original}
                disabled
              />
            </div>
            <div className="flex flex-col select-none">
              <label
                className="text-accent-300 dark:text-accent-200 font-medium text-sm mb-1"
                htmlFor="shorten"
              >
                Shorten
              </label>
              <input
                className="w-full border text-accent-400 dark:text-accent-100 dark:bg-accent-700 disabled:hover:cursor-not-allowed dark:border-none disabled:dark:text-accent-300 select-none bg-primary-50 border-accent-100 rounded-md py-2 px-10px outline-none font-bold focus-within:border-primary-500"
                type="text"
                id="shorten"
                placeholder="Type new title"
                value={"snil.ink/" + short}
                disabled
              />
            </div>
            <div className="flex mt-20px w-full justify-end gap-16px text-sm font-medium">
              <button
                type="button"
                className="bg-transparent border border-accent-100 rounded-lg px-12px py-[6px] text-accent-400 dark:border-accent-400 dark:text-accent-200 focus-within:outline-primary-500"
                onClick={() => setConfirmingEdit(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className=" bg-primary-400 dark:bg-primary-500 dark:disabled:bg-accent-400 disabled:bg-accent-200 disabled:cursor-not-allowed text-white py-2 px-16px  rounded-md"
                disabled={!changeDetected}
                onClick={() => handleSave()}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ConfirmEdit;
